<template>
    <!-- the shots of one player in one match: the court of the match page, with a short legend -->
    <div class="player-shots">
        <shot-court :shots="dots" :dot-size="14" />
        <div class="player-shots__legend">
            <span><i class="player-shots__dot player-shots__dot--made" :style="{ background: color, borderColor: color }" />Εύστοχα <b>{{ made }}</b></span>
            <span><i class="player-shots__dot" :style="{ borderColor: color }" />Άστοχα <b>{{ dots.length - made }}</b></span>
        </div>
    </div>
</template>

<script>
    import ShotCourt from '@/components/ShotCourt'
    import { shotSpot, getShotPoints, resolveShotPeriod } from '@/utils/shotChart'

    export default {
        name: 'ShootingChart',
        components: { ShotCourt },
        props: {
            shots: {
                type: Array,
                default: () => []
            },
            color: {
                type: String,
                default: '#ff7133'
            }
        },
        computed: {
            // the stored positions as dots on the spot of every shot
            dots() {
                return (this.shots || [])
                    .filter(shot => shot && Number.isFinite(Number(shot.x)) && Number.isFinite(Number(shot.y)))
                    .map((shot, index) => {
                        const spot = shotSpot(shot)
                        return {
                            id: index,
                            x: Math.max(0, Math.min(1, spot.x)),
                            y: Math.max(0, Math.min(1, spot.y)),
                            made: shot.throwStatus === 'made',
                            points: getShotPoints(shot),
                            period: resolveShotPeriod(shot),
                            color: this.color
                        }
                    })
            },
            made() {
                return this.dots.filter(dot => dot.made).length
            }
        }
    }
</script>

<style scoped>
/* the size of the old court of the cards (350px), smaller only on a narrow phone */
.player-shots {
    width: 350px;
    max-width: 100%;
    margin: 0 auto;
}

.player-shots__legend {
    display: flex;
    justify-content: center;
    gap: 18px;
    margin-top: 8px;
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.6);
}

.player-shots__legend span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.player-shots__legend b {
    color: rgba(0, 0, 0, 0.87);
}

.player-shots__dot {
    width: 11px;
    height: 11px;
    border: 2px solid;
    border-radius: 50%;
    background: #fff;
}
</style>
